import request from '@/utils/request';
// 换电统计数据
export function getOpenDataStatisticData () {
  return request({
    url: '/analyse/openData/statisticData',
    method: 'post',
  });
}

// 换电页面所有数据
export function getAllData () {
  return request({
    url: '/webapi/saasIgnore/fuzhou/traffic/statisticDataSummary',
    method: 'get',
  });
}

/**
 * 近10天用户量
 */
export function getChartUserTenDays () {
  return request({
    url: '/analyse/openData/chartUserTenDays',
    method: 'post',
  });
}

/**
 * 近10天电池使用数量
 */
export function getChartBatteryTenDays () {
  return request({
    url: '/analyse/openData/chartBatteryTenDays',
    method: 'post',
  });
}

/**
 * 近10天套餐收益
 */
export function getChartComboTenDays () {
  return request({
    url: '/analyse/openData/chartComboTenDays',
    method: 'post',
  });
}

/**
 * 今日统计数据
 */
export function getStatisticToday () {
  return request({
    url: '/analyse/openData/statisticToday',
    method: 'post',
  });
}

/**
 * 在线电池数据
 */
export function getStatisticBatteryLine () {
  return request({
    url: '/analyse/openData/statisticBatteryLine',
    method: 'post',
  });
}

/**
 * 在线换电柜数据
 */
export function getStatisticCabinetLine () {
  return request({
    url: '/analyse/openData/statisticCabinetLine',
    method: 'post',
  });
}

/**
 * 资源数据
 */
export function getStatisticAssetData () {
  return request({
    url: '/analyse/openData/statisticAssetData',
    method: 'post',
  });
}
